import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
    }

    #root {
        min-height: 100%;
    }

    img {
        max-width: 100%;
        height: auto;
    }

    body {
        background: ${({ theme }) => theme.colors.background};
        font-family: 'Inter', sans-serif;
        color: ${({ theme }) => theme.colors.gray[900]};
    }
    
    button {
        cursor: pointer;
        font-family: inherit;
    }

`
